import { useState } from "react";

import Popover from "@/components/ui/Popover/Popover";


import { cn } from "@/utils/helpers/classnames";
import { SlidersHorizontal } from "lucide-react";

type FilterButtonProps = {
  children: (props: { closeModule: () => void }) => React.ReactNode;
  trigger?: React.ReactNode;
  align?: "start" | "center" | "end";
  sideOffset?: number;
  triggerClassName?: string;
  showTriggerIcon?: boolean;
  triggerIconClassName?: string;
  triggerIcon?: React.ReactNode;
  triggerLabel?: string;
  activeCount?: number;
  containerClassName?: string;
};

const FilterButton = ({
  children,
  trigger,
  align = "end",
  sideOffset = 10,
  triggerClassName,
  showTriggerIcon = true,
  triggerIconClassName,
  triggerIcon,
  triggerLabel = "Filter",
  activeCount = 0,
  containerClassName
}: FilterButtonProps) => {
  const [open, setOpen] = useState(false);

  const defaultTrigger = (
    <button
      aria-expanded={open}
      aria-haspopup='dialog'
      className={cn(
        "px-4 py-2 rounded-lg inline-flex items-center gap-2 transition-colors duration-300",
        activeCount > 0
          ? "bg-wine-100 text-white hover:bg-wine-200"
          : "bg-black text-white hover:bg-gray-900",
        triggerClassName
      )}
      data-id='filter-button'
    >
      {showTriggerIcon && (triggerIcon ?? <SlidersHorizontal className={cn("w-4 h-4", triggerIconClassName)} />)}
      <span className='text-base font-medium'>{triggerLabel}</span>
      {activeCount > 0 && (
        <span
          aria-label={`${activeCount} active filter${activeCount !== 1 ? "s" : ""}`}
          className='w-5 h-5 rounded-full bg-white text-wine-100 text-xs font-bold flex items-center justify-center'
        >
          {activeCount}
        </span>
      )}
    </button>
  );

  return (
    <div className={cn(`relative z-50 flex w-max items-center gap-2 ${containerClassName}`)}>
      <Popover
        trigger={trigger ?? defaultTrigger}
        align={align}
        collisionPadding={8}
        sideOffset={sideOffset}
        open={open}
        onOpenChange={setOpen}
        contentClassName='!p-0 !overflow-visible'
        side='bottom'
      >
        {children({ closeModule: () => setOpen(false) })}
      </Popover>
    </div>
  );
};

export default FilterButton;
